var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"appear":_vm.intro,"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"Auction"},[_c('auction-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]}),_vm._v(" "),_c('close-link',{attrs:{"to":_vm.closeTo}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d1819d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/Auction.vue
// module id = null
// module chunks = 